/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { N0 } from '@atlaskit/theme/colors';
import CustomIcon from '@atlaskit/icon';
import { AtlassianIcon } from '@atlaskit/logo';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import Figma24Icon from '@atlaskit/icon-file-type/glyph/figma/24';
import Sketch24Icon from '@atlaskit/icon-file-type/glyph/sketch/24';
import tokensIcon from '../icons/tokens.svg';
// @ts-expect-error
import loadable from '@loadable/component';

const LazyIcon = loadable(({ glyph }: { glyph: string }) => {
  return import(
    /* webpackChunkName: "@atlaskit-internal_icon/glyph/[request]" */ `@atlaskit/icon/glyph/${glyph}`
  ).catch(() => ({
    default: QuestionCircleIcon,
  }));
});

const IconWrapperStyles = css({
  fontSize: 0,
  path: { fill: token('elevation.surface.raised', N0) },
});

const Icon = ({
  glyph,
  secondaryColor,
}: {
  glyph: string;
  secondaryColor: string;
}) => {
  if (glyph === 'logo') {
    return (
      <AtlassianIcon
        iconColor={token('elevation.surface.raised', N0)}
        size={'small'}
      />
    );
  } else if (glyph === 'sketch') {
    return (
      <span css={IconWrapperStyles}>
        <Sketch24Icon label="" />
      </span>
    );
  } else if (glyph === 'figma') {
    return (
      <span css={IconWrapperStyles}>
        <Figma24Icon label="" />
      </span>
    );
  } else if (glyph === 'tokens') {
    return (
      <span css={IconWrapperStyles}>
        {/* @ts-expect-error should this be dangerousSetInnerGlyph? */}
        <CustomIcon glyph={tokensIcon} label="tokens icon" />
      </span>
    );
  } else if (glyph === 'elevation') {
    return (
      <span css={IconWrapperStyles}>
        {/* @ts-expect-error should this be dangerousSetInnerGlyph? */}
        <CustomIcon glyph={elevationIcon} label="elevation icon" />
      </span>
    );
  } else {
    return (
      <LazyIcon
        glyph={glyph}
        primaryColor={token('elevation.surface.raised', N0)}
        secondaryColor={secondaryColor}
      />
    );
  }
};

const iconTileStyles = css({
  width: '48px',
  height: '48px',
  borderRadius: '4px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

interface IconTileProps {
  glyph: string;
  background: string;
}

const IconTile = ({ glyph, background }: IconTileProps) => {
  const backgroundColorStyles = css({ backgroundColor: background });

  return (
    <div css={[iconTileStyles, backgroundColorStyles]}>
      <Icon glyph={glyph} secondaryColor={background} />
    </div>
  );
};

export default IconTile;
